// extracted by mini-css-extract-plugin
module.exports = {"main":"PreviewBlock_main__1Dqpz","Content":"PreviewBlock_Content__2RgnX"};